export const assetSupplierConstants = {
  API_INSERT: '/api/supplier/insert',
  API_UPDATE: '/api/supplier/update',
  API_DELETE: '/api/supplier/delete',
  API_GET: '/api/supplier/',
  API_GETALL: '/api/supplier/getall',

  INSERT_REQUEST: 'ASSET_SUPPLIER_INSERT_REQUEST',
  INSERT_SUCCESS: 'ASSET_SUPPLIER_INSERT_SUCCESS',
  INSERT_FAILURE: 'ASSET_SUPPLIER_INSERT_FAILURE',

  UPDATE_REQUEST: 'ASSET_SUPPLIER_UPDATE_REQUEST',
  UPDATE_SUCCESS: 'ASSET_SUPPLIER_UPDATE_SUCCESS',
  UPDATE_FAILURE: 'ASSET_SUPPLIER_UPDATE_FAILURE',

  DELETE_REQUEST: 'ASSET_SUPPLIER_DELETE_REQUEST',
  DELETE_SUCCESS: 'ASSET_SUPPLIER_DELETE_SUCCESS',
  DELETE_FAILURE: 'ASSET_SUPPLIER_DELETE_FAILURE',

  GET_REQUEST: 'ASSET_SUPPLIER_GET_REQUEST',
  GET_SUCCESS: 'ASSET_SUPPLIER_GET_SUCCESS',
  GET_FAILURE: 'ASSET_SUPPLIER_GET_FAILURE',

  GETALL_REQUEST: 'ASSET_SUPPLIER_GETALL_REQUEST',
  GETALL_SUCCESS: 'ASSET_SUPPLIER_GETALL_SUCCESS',
  GETALL_FAILURE: 'ASSET_SUPPLIER_GETALL_FAILURE',

  RESET: 'ASSET_SUPPLIER_RESET',
  SERVICE: 'ASSET_SUPPLIER_SERVICE',
};
